import { useEffect, useState } from "react";

const COPIED_FEEDBACK_MS = 2000;

/**
 * Clipboard write plus a short-lived `copied` flag, so a copy button can show
 * that it worked. Shared by the row's copy icon and the expanded row's Copy /
 * Copy JSON buttons.
 */
export function useCopyFeedback() {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return { copied, copy };
}
